var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterInstagramDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2410_31686)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 9.3125C9.78864 9.3125 7.99255 11.1086 7.99255 13.3198C7.99255 15.5311 9.78864 17.3315 11.9999 17.3315C14.2111 17.3315 16.0116 15.5311 16.0116 13.3198C16.0116 11.1086 14.2111 9.3125 11.9999 9.3125Z",
    fill: "#E3E9EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0481 2.39648H5.95179C3.26422 2.39648 1.07483 4.58587 1.07483 7.27345V19.3697C1.07483 22.0617 3.26422 24.2467 5.95179 24.2467H18.0481C20.74 24.2467 22.925 22.0617 22.925 19.3697V7.27345C22.925 4.58587 20.74 2.39648 18.0481 2.39648ZM11.9999 20.401C8.09748 20.401 4.92046 17.224 4.92046 13.3216C4.92046 9.41914 8.09748 6.24649 11.9999 6.24649C15.9024 6.24649 19.0794 9.41914 19.0794 13.3216C19.0794 17.224 15.9024 20.401 11.9999 20.401ZM19.228 7.53128C18.402 7.53128 17.729 6.86266 17.729 6.03673C17.729 5.21079 18.402 4.5378 19.228 4.5378C20.0539 4.5378 20.7269 5.21079 20.7269 6.03673C20.7269 6.86266 20.0539 7.53128 19.228 7.53128Z",
    fill: "#E3E9EE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2410_31686"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.398438)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterInstagramDark);
export default __webpack_public_path__ + "static/media/FooterInstagramDark.d47966e56ade3bf86a570f43b43d7e87.svg";
export { ForwardRef as ReactComponent };